<div class="upsell-sticky-bar-v2 bg-white fixed w-full montserrat">
  <div class="upsell-sticky-bar-v2__container mx-auto w-full p-4 desktop:flex desktop:flex-row desktop:items-center desktop:justify-around">
    <div class="upsell-sticky-bar-v2__content flex gap-10 justify-center items-center desktop:flex-row">
      <img class="p1 upsell-sticky-bar-v2__image h-20 desktop:h-16" [src]="productImage" [alt]="productName">
      <div class="desktop:flex desktop:flex-row desktop:items-center desktop:gap-16">
        <div class="p2">
          <div class="gundry-darkblue flex gap-1">
            <span [innerHTML]="productBrand"></span>
            <span class="font-bold" [innerHTML]="productName"></span>
          </div>
          <div class="flex gap-1">
            <span [innerHTML]="productQuantity"></span>
            <span [innerHTML]="productUnitType"></span>
          </div>
        </div>
        <div class="p3 text-2xl flex gap-1 items-end">
          Total: <span>{{productYourPrice | dynamicCurrency:currency}}</span>
          <span class="text-xl">{{ currency !== 'USD' ? currency : '' }}</span>
        </div>
      </div>
    </div>
    <div class="p4 upsell-sticky-bar-v2__CTA" (click)="nextPage(true)">
      <div class="upsell-sticky-bar-v2__button cursor-pointer p-1 mt-3 desktop:mt-0 text-white text-center font-bold text-2xl desktop:px-10 rounded-md">
        Add to Order
      </div>
    </div>
    
  </div> 
</div>